import type { Locale } from 'date-fns'

// Register the calendar dictionary alongside each new supported UI language.
const loaders: Record<string, () => Promise<Locale>> = {
  en: () => import('date-fns/locale/en-US').then(module => module.enUS),
  ar: () => import('date-fns/locale/ar').then(module => module.ar),
}
const loaded: Record<string, Locale> = {}

export async function loadCalendarLocale(code: string): Promise<void> {
  if (loaded[code]) return
  if (!loaders[code]) throw new Error(`Missing calendar locale: ${code}`)
  loaded[code] = await loaders[code]()
}

export function calendarLocale(code: string): Locale | undefined {
  return loaded[code]
}
